import type {
  MobilePlanOffer,
  MobilePlanPartnerName,
} from '@backmarket/http-api/src/api-specs-partnerships/mobile-plan/types/mobile-plan-offers'

import type { CartItem } from '@backmarket/nuxt-layer-checkout/api/cart/types'

export function getSelectedMobilePlanCartItem(
  items: CartItem[],
  options?: {
    partnerName?: MobilePlanPartnerName
    type?: MobilePlanOffer['type']
  },
): CartItem | undefined {
  return items.find((item) => {
    if (!item.mobilePlan) return false

    if (
      options?.partnerName &&
      item.mobilePlan.selectedOffer.partner.name !== options.partnerName
    ) {
      return false
    }

    if (options?.type && item.mobilePlan.selectedOffer.type !== options.type) {
      return false
    }

    return true
  })
}
